import {
  IDevConfigInterface,
  IProdConfigInterface,
  IStageConfigInterface,
} from "@/configs/interface";
import envConfig from "envConfig";

export const useConfiguration = () => {
  const configuration = envConfig as
    | IProdConfigInterface
    | IDevConfigInterface
    | IStageConfigInterface;
  return configuration;
};
